/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import classNames from 'classnames';
import PcModelOptionsSubGroupLists from 'containers/PcModel/PcModelOptionsSubGroupLists';
import PcModelOptionsSubGroupTabs from 'containers/PcModel/PcModelOptionsSubGroupTabs';
import { CommaArrayParam } from 'helpers/CommaArrayParam';
import { getGroupInfo } from 'helpers/getGroupInfo';
import Image from 'next/image';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import {
  JsonParam,
  StringParam,
  useQueryParam,
  withDefault,
} from 'use-query-params';
import PcModelDelayAlert from '../PcModelDelayAlert';
import PcModelOptionImage from '../PcModelOptionImage';
import PcModelOptionImageWithModal from '../PcModelOptionImageWithModal';
import ValidationAlert from '../PcModelValidationAlert';
import styles from './styles';
import useScreenWidth from 'utils/useScreenWidth';
import PcModelNoticeAlert from '../PcModelNoticeAlert';
import PcModelNoticeAlertGen from '../PcModelNoticeAlertGen';
import PcModelOptionImageCarousel from '../PcModelOptionImageCarousel';

const PcModelOptionsGroup = ({
  pcModel,
  errors,
  allSubGroups,
  groupType,
  target_upgrade_id,
  options,
  modelTheme,
}) => {
  const groupInfo = getGroupInfo(pcModel, groupType);

  if (groupType === 'charms') {
    return;
  }

  const baseOption = options.find(
    (option) => option.group_type === groupType && option.is_base,
  );
  // console.log(allSubGroups);

  const specialIds = [];

  pcModel?.modelOptionGroup?.forEach((optionGroup) =>
    optionGroup.options.forEach((option) => {
      if (option.on_special === 1) {
        specialIds.push(option.option_id);
      }
    }),
  );

  if (!baseOption) return null;

  const [completed, setCompleted] = useQueryParam(
    'completed',
    withDefault(CommaArrayParam, []),
  );

  const [step] = useQueryParam('step', withDefault(StringParam, ''));

  const widthSize = useScreenWidth();
  const [isExpanded, setIsExpanded] = useState(true);

  useEffect(() => {
    if (
      groupType === 'samsung_monitors_aftershock_recommended' ||
      groupType === 'steelseries_accessories_aftershock_recommended' ||
      groupType === 'free_gift' ||
      groupType === 'norton_vpn_software' ||
      groupType === 'pax_weekend_only_free_nzxt_keyboard_with_purchase'
    ) {
      setIsExpanded(false);
    }
  }, [groupType]);
  useEffect(() => {
    if (step === 'accessories') {
      setIsExpanded(false);
    }
  }, [step]);

  const subGroups = allSubGroups
    .filter(
      (subGroup) =>
        subGroup.group_type === groupType &&
        subGroup.option_sub_group_id !== 0 &&
        subGroup.option_sub_group_id !== null,
    )
    .sort((a, b) => a?.option_sub_group_id - b?.option_sub_group_id);

  const [currentSelections, setCurrentSelections] = useQueryParam(
    'selections',
    JsonParam,
  );

  const currentOption = options.find((option) => {
    if (
      groupType === 'cpu_cooling_system' &&
      currentSelections?.cpu_cooling_system_print
    ) {
      return option.variant_id === currentSelections.cpu_cooling_system_print;
    }
    if (groupType === 'gpu_customisation' && currentSelections?.charms) {
      return option.variant_id === currentSelections.charms;
    }
    const variantId = currentSelections?.[groupType] || baseOption?.variant_id;
    return option.variant_id === variantId;
  });

  // Created current cpu variable for the filtering cpu cooling system
  const currentCpu = options.find((option) => {
    if (currentSelections?.cpu) {
      return currentSelections?.cpu === option?.variant_id;
    } else {
      return option.group_type === 'cpu' && option.is_base === true;
    }
  });

  const groupOptions = options
    .filter((option) => option.group_type === groupType)
    .filter((option) => {
      if (groupType === 'cpu_cooling_system' && currentCpu) {
        return !option.tags
          .flat()
          .some(
            (tag) =>
              tag.name === 'brand' &&
              tag.operator === currentCpu?.tags[0][0].value,
          );
      }
      return true;
    })
    .sort((a, b) => a?.option_id - b?.option_id);

  const [selectedSubGroup, setSelectedSubGroup] = useState(null);

  const groupErrors = errors.filter(
    (error) =>
      error?.option?.group_type === groupType ||
      error?.target?.group_type === groupType,
  );

  // ---------- check for selected motherboard if usb type c included
  const currentMotherboard = options.find((option) => {
    const variantId =
      currentSelections?.['motherboard'] || baseOption.variant_id;
    return option.variant_id === variantId;
  });

  const flatAttrTags = currentMotherboard.tags.flat();
  const checkUSBC = flatAttrTags.find((el) => el.name == 'usbc_included');
  // ----------

  // ---------- check for selected motherboard if support gen 5
  const currentMotherboardTags =
    pcModel.modelOptionGroup[1].options.find(
      (motherboard) => motherboard.option_id === currentMotherboard.option_id,
    )?.component.tags ||
    pcModel.modelOptionGroup[1].options.find(
      (motherboard) => motherboard.base === 1,
    )?.component.tags;
  const motherboardGen = currentMotherboardTags
    ?.split(', ')
    .find((attributes) => attributes.includes('rec:ssd_gen:is:'))
    ?.split('rec:ssd_gen:is:')[1];
  const currentPrimarySsd = options.find((option) => {
    const variantId =
      currentSelections?.['primary_ssd'] || baseOption.variant_id;
    return option.variant_id === variantId;
  });
  const currentPrimarySsdGen = currentPrimarySsd.tags
    .flat()
    .find((tag) => tag.name === 'ssd_gen')?.value;
  // ----------

  const groupTitle = groupInfo?.optionGroup?.option_group_title;

  const handleResetClick = () => {
    setCurrentSelections({
      ...currentSelections,
      [groupType]: undefined,
    });
    setCompleted(undefined);
  };

  const handleSaveClick = () => {
    setCompleted(completed.concat(groupType));
    const topOfElement =
      document.getElementById(`group-type-${groupType}`).offsetTop - 100;
    window.scroll({ top: topOfElement, behavior: 'smooth' });
  };

  const handleExpandToggle = () => {
    setIsExpanded((prev) => !prev);
    if (widthSize <= 500 && widthSize != null) {
      // MOBILE
      if (modelTheme.toggle_components_mobile) {
        setCompleted(
          !isExpanded
            ? completed.concat(groupType)
            : completed.filter((item) => item !== groupType),
        );
      } else {
        setCompleted(
          isExpanded
            ? completed.concat(groupType)
            : completed.filter((item) => item !== groupType),
        );
      }
    } else if (widthSize > 500 && widthSize != null) {
      // DESKTOP
      if (modelTheme.toggle_components_desktop) {
        setCompleted(
          !isExpanded
            ? completed.concat(groupType)
            : completed.filter((item) => item !== groupType),
        );
      } else {
        setCompleted(
          isExpanded
            ? completed.concat(groupType)
            : completed.filter((item) => item !== groupType),
        );
      }
    }
  };

  // Function for calculating used pcie slots
  const calculateUsedPCIESlots = (options, selections) => {
    if (!selections) {
      return 0;
    }

    let usedSlots = 0;

    Object.keys(selections).forEach((groupType) => {
      const selectedOption = options.find(
        (option) => option.variant_id === selections[groupType],
      );
      if (selectedOption) {
        selectedOption.tags.flat().forEach((tag) => {
          if (tag.name === 'pcie_slots' && tag.operator === 'min') {
            usedSlots += parseInt(tag.value, 10);
          }
        });
      }
    });

    return usedSlots;
  };

  // Check if the current selections exceed the available PCIe slots
  const motherboard = options.find((option) => {
    if (
      option.group_type === 'motherboard' &&
      option.variant_id === currentSelections?.motherboard
    ) {
      return option;
    } else if (
      !currentSelections?.motherboard &&
      option.group_type === 'motherboard' &&
      option.is_base
    ) {
      return option;
    }
  });
  const availableSlots = motherboard
    ? parseInt(
        motherboard.tags.flat().find((tag) => tag.name === 'pcie_slots')?.value,
        10,
      )
    : 0;
  const usedSlots = calculateUsedPCIESlots(options, currentSelections);

  if (
    usedSlots > availableSlots &&
    availableSlots !== NaN &&
    (groupType === 'network_card' || groupType === 'capture_card')
  ) {
    groupErrors.push({
      attr: 'pcie_slots',
      operator: 'exceed',
      is_aggr: true,
      option: motherboard,
      target: null,
      value: availableSlots,
    });
  }

  // console.log('availableSlots', availableSlots, 'usedSlots', usedSlots);

  const [isHovered, setIsHovered] = useState(false);

  const sortedGroupOptions = groupOptions.sort((a, b) => a.price - b.price);
  const images = sortedGroupOptions
    .filter((option) => option.price !== 0)
    .map((option) => ({
      src: option.image.src,
      alt: option.image.alt,
    }));

  return (
    <div
      id={`group-type-${groupType}`}
      className={classNames('options-group ', {
        error_group: groupErrors?.length,
        delayed_group:
          (!groupErrors?.length && !currentOption?.in_stock) ||
          (motherboardGen === '4' &&
            currentPrimarySsdGen == '5' &&
            (groupType == 'motherboard' || groupType == 'primary_ssd')),
        removed_item_group: !currentOption,
      })}
    >
      {groupErrors.length > 0 && (
        <div className="error_icon">
          <Image
            draggable={false}
            src="https://cdn.shopify.com/s/files/1/0522/3320/7988/files/icon-exclamation-blue.svg?v=1713944876"
            alt="Error"
            width={16}
            height={16}
          />
        </div>
      )}

      {(groupErrors?.length === 0 && !currentOption?.in_stock) ||
        (motherboardGen === '4' &&
          currentPrimarySsdGen == '5' &&
          (groupType == 'motherboard' || groupType == 'primary_ssd') && (
            <div className="error_icon">
              <Image
                draggable={false}
                src="https://cdn.shopify.com/s/files/1/0522/3320/7988/files/icon-exclamation-blue.svg?v=1713944876"
                alt="Error"
                width={16}
                height={16}
              />
            </div>
          ))}

      {!currentOption && (
        <div className="error_icon">
          <Image
            draggable={false}
            src="https://cdn.shopify.com/s/files/1/0522/3320/7988/files/icon-exclamation-yellow.svg?v=1713945250"
            alt="Error"
            width={16}
            height={16}
          />
        </div>
      )}

      {modelTheme.toggle_design ? (
        <div
          className="heading-new"
          onClick={() => handleExpandToggle(groupType)}
          style={isExpanded ? { border: 0 } : { border: '2px solid #282828' }}
        >
          {!isExpanded && (
            <div
              className="expand-toggle"
              onClick={() => handleExpandToggle(groupType)}
            >
              <PcModelOptionImage
                src={currentOption?.image?.src}
                alt={currentOption?.image?.alt}
                width={120}
                height={120}
              />
            </div>
          )}

          <div className="heading-text">
            <div className="heading-title">{groupTitle}</div>
            <div className="heading-selected">
              {currentOption?.title}
              {!isExpanded && <span className="edit-bracket">[ edit ]</span>}
            </div>
            {!isExpanded && (
              <span className="edit-bracket-mobile">[ edit ]</span>
            )}
            {!isExpanded ? (
              <div className="toggle-icon-con">
                <img
                  draggable="false"
                  src={
                    'https://cdn.shopify.com/s/files/1/0522/3320/7988/files/ChevronDown.svg?v=1713890140'
                  }
                  className="toggle-icon"
                />
              </div>
            ) : (
              <div className="toggle-icon-con">
                <img
                  draggable="false"
                  src={
                    'https://cdn.shopify.com/s/files/1/0522/3320/7988/files/ChevronUp.svg?v=1713890188'
                  }
                  className="toggle-icon"
                />
              </div>
            )}
          </div>
        </div>
      ) : (
        <div
          className="heading"
          onClick={() => handleExpandToggle(groupType)}
          onMouseEnter={() => {
            setIsHovered(true);
          }}
          onMouseLeave={() => {
            setIsHovered(false);
          }}
        >
          <div className="heading-text">
            <div className="heading-title">{groupTitle}</div>
            <div className="heading-selected">{currentOption?.title}</div>
          </div>

          {!isExpanded && (
            <div
              className="expand-toggle"
              onClick={() => {
                handleExpandToggle(groupType);
                setIsExpanded(false);
              }}
            >
              {isHovered && step === 'accessories' ? (
                <PcModelOptionImageCarousel
                  images={images}
                  width={120}
                  height={120}
                  isHovered={isHovered}
                />
              ) : (
                <PcModelOptionImage
                  src={currentOption?.image?.src}
                  alt={currentOption?.image?.alt}
                  width={120}
                  height={120}
                />
              )}
            </div>
          )}
        </div>
      )}

      {isExpanded && (
        <div className="expanded">
          {groupInfo.model_option_group_description && (
            <div className="description">
              <div className="description-value">
                {groupInfo?.model_option_group_description}
              </div>
            </div>
          )}

          {/* {groupInfo.group_note.length > 0 && (
            <div className="note">
              <div className="note-label">Note</div>
              <div className="note-value">
                {RichText.render(groupInfo?.group_note)}
              </div>
            </div>
          )} */}

          {groupErrors.length > 0 && (
            <ValidationAlert key={groupErrors} errors={groupErrors} />
          )}

          {currentOption && !currentOption?.in_stock && <PcModelDelayAlert />}

          {!currentOption && <PcModelDelayAlert type="removed" />}

          {/* show only on motherboard component */}
          {checkUSBC?.value == 'false' && groupType == 'motherboard' && (
            <PcModelNoticeAlert type="usbc_included" />
          )}
          {motherboardGen === '4' &&
            currentPrimarySsdGen == '5' &&
            (groupType == 'motherboard' || groupType == 'primary_ssd') && (
              <PcModelNoticeAlertGen type="lower_gen" />
            )}

          <div className="options">
            <div className="options-image-wrapper">
              <div className="options-image">
                <PcModelOptionImageWithModal
                  src={currentOption?.image?.src}
                  alt={currentOption?.image?.alt}
                  width={500}
                  height={500}
                  groupTitle={groupTitle}
                  options={groupOptions}
                  allOptions={options}
                  groupType={groupType}
                  currentOption={currentOption}
                  subGroups={subGroups}
                  selectedSubGroup={selectedSubGroup}
                />
              </div>
            </div>

            <div className="options-list" data-groupListType={groupType}>
              <PcModelOptionsSubGroupTabs
                groupType={groupType}
                subGroups={subGroups}
                selectedSubGroup={selectedSubGroup}
                onTabClick={(subGroup) => setSelectedSubGroup(subGroup)}
              />

              <PcModelOptionsSubGroupLists
                groupType={groupType}
                subGroups={subGroups}
                selectedSubGroup={selectedSubGroup}
                options={groupOptions}
                allOptions={options}
                specialIds={specialIds}
                target_upgrade_id={target_upgrade_id}
              />
            </div>
          </div>

          <div className="actions">
            {/* <button
              type="button"
              className="button--link actions-reset"
              onClick={handleResetClick}
            >
              Reset to base
            </button> */}

            <button
              className="collapse"
              type="button"
              onClick={handleSaveClick}
            >
              COLLAPSE
              <div className="saveIcon">
                <Image
                  draggable={false}
                  src="https://cdn.shopify.com/s/files/1/0522/3320/7988/files/ChevronUpDouble.svg?v=1713889996"
                  alt="save"
                  width={24}
                  height={24}
                />
              </div>
            </button>
          </div>
        </div>
      )}
      <style jsx>{styles}</style>
    </div>
  );
};

PcModelOptionsGroup.propTypes = {
  groupType: PropTypes.string.isRequired,
};

export default PcModelOptionsGroup;
